import Select from 'react-select';

const ServiceLocationFilter = ({ 
  serviceLocations, 
  selectedServiceLocation, 
  selectedLocationAddress, 
  handleServiceLocationChange 
}) => {
  // Prepare options for react-select
  const locationOptions = serviceLocations.map((location) => ({
    value: location._id,
    label: location.location_name
  }));
  // Handle react-select change
  const handleSelectChange = (selectedOption) => {
    handleServiceLocationChange(selectedOption ? selectedOption.value : '');
  };

  return (
    <>
      <div className="flex items-center mr-6">
        <label className="text-sm font-medium text-gray-700 mr-3">
          Service Location
        </label>
        <Select
          value={locationOptions.find(option => option.value === selectedServiceLocation) || null}
          onChange={handleSelectChange}
          options={locationOptions}
          placeholder="Select service location..."
          isClearable
          className="w-48"
          classNamePrefix="react-select"
          styles={{
            control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#0B6D76' : '#d1d5db',
                '&:hover': {
                    borderColor: '#9ca3af',
                },
                boxShadow: state.isFocused ? '0 0 0 2px rgba(11, 109, 118, 0.1)' : 'none',
                borderRadius: '0.375rem',
                minHeight: '40px',
                fontSize: '0.875rem',
            }),
            option: (baseStyles) => ({
                ...baseStyles,
                padding: '8px 12px',
                fontSize: '0.875rem',
            }),
        }}
        />
      </div>

      {/* Service Location Address */}
      {selectedLocationAddress && (
        <div className="mr-6 flex items-center">
          <div className="text-xs text-gray-500 leading-tight px-3 py-2 rounded-lg flex items-center justify-center" style={{width: '183px', height: '48px', backgroundColor: '#EFEFEF'}}>
            {selectedLocationAddress}
          </div>
        </div>
      )}
    </>
  );
};

export default ServiceLocationFilter;
